<template>
  <wheelLuck />
</template>

<script>
import wheelLuck from "@/components/wheelLuck.vue";

export default {
  name: "Home",

  components: {
    wheelLuck,
  },
};
</script>

<style>
/* main {
  background-image: url("../assets/pexels-francesco-ungaro-5087702.jpg");
  background-position: center;
  background-repeat: no-repeat;
} */
</style>
